var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0393 14.1974L4.81257 16.4041C4.20416 16.7217 3.49541 16.2046 3.61221 15.5283L4.41813 10.8621L1.00316 7.55647C0.508324 7.07748 0.779625 6.23893 1.46126 6.14058L6.18541 5.45889L8.29706 1.20997C8.60185 0.596677 9.47674 0.596677 9.78154 1.20997L11.8932 5.45889L16.6173 6.14058C17.299 6.23893 17.5703 7.07748 17.0754 7.55647L13.6605 10.8621L14.4664 15.5283C14.5832 16.2046 13.8744 16.7217 13.266 16.4041L9.0393 14.1974ZM8.65562 12.5275C8.89595 12.4021 9.18246 12.4021 9.4228 12.5275L12.5476 14.1589L11.9523 10.7123C11.9056 10.4422 11.9956 10.1664 12.1926 9.97571L14.7089 7.53999L11.226 7.03741C10.9565 6.99853 10.7233 6.82977 10.6021 6.58594L9.03921 3.44113L7.47629 6.58594C7.35511 6.82977 7.12191 6.99853 6.85242 7.03741L3.36956 7.53999L5.88585 9.97571C6.08285 10.1664 6.1728 10.4422 6.12614 10.7123L5.53086 14.1589L8.65562 12.5275Z",
    fill: "#027EFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.cf5405d42c171f2278610df860134dfa.svg";
export { ForwardRef as ReactComponent };